import { useKeycloak } from "@react-keycloak/web";
import UserProfileTemplate from "../../Templates/UserProfile";
import { useEffect, useState } from "react";
import React from "react";
import UserProfileSkeleton from "./UserProfileSkeleton";

const UserProfilePage = () => {
  const { keycloak } = useKeycloak();
  const accessToken = keycloak.token;

  const [userInfos, setUserInfos] = useState({});
  const fetchUserData = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_AUTH_API_URL + "/users/me",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const data = await response.json();
      const {
        createdAt,
        totalSpentTokens,
        trialPeriodDays,
        trialPeriodRemainingDays,
        trialRemainingTokens,
      } = data;
      setUserInfos({
        createdAt,
        totalSpentTokens,
        trialPeriodDays,
        trialPeriodRemainingDays,
        trialRemainingTokens,
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const validateUserInfos = (userInfos) => {
    return Object.keys(userInfos).length === 5;
  };

  useEffect(() => {
    if (accessToken) {
      fetchUserData();
    }
  }, [accessToken]);

  return (
    <>
      {validateUserInfos(userInfos) ? (
        <UserProfileTemplate userInfos={userInfos} />
      ) : (
        <UserProfileSkeleton />
      )}
    </>
  );
};

export default UserProfilePage;
